export enum TemplateType {
  Default = 'default',
  Achbd = 'achbd',
}
